const initWinterResortPageReadMore = (element = document) => {
    const readMoreButton = element.getElementsByClassName('winter-resort-page__hidden-info__button');

    Array.from(readMoreButton).forEach(_button => {
      const button = _button;
        button.addEventListener('click', () => {
            //get parent then get child div __content
            const content = button.parentElement.getElementsByClassName('winter-resort-page__hidden-info__content');
            if (content.length === 0) {
                return;
            }
            Velocity(content[0], content[0].classList.contains('--visible') ? 'slideUp' : 'slideDown');
            content[0].classList.toggle('--visible');
            button.innerHTML = `<span class="button__text">Read ${content[0].classList.contains('--visible') ? 'less' : 'more'}</span>`;
        });
    });
};

export default initWinterResortPageReadMore;
